import { Component, Input, OnInit } from '@angular/core';
import { AccordionTabCloseEvent, AccordionTabOpenEvent } from 'primeng/accordion';

@Component({
  selector: 'app-painel',
  templateUrl: './painel.component.html',
  styleUrls: ['./painel.component.css'],
  standalone: false
})
export class PainelComponent implements OnInit {

  @Input() title: string = '';
  @Input() opened = false;
  @Input() classe = 'painel-page';
  @Input() bgColor: string = '#eef2f6';
  isPanelOpen = false;

  constructor() { }

  ngOnInit() {
    this.isPanelOpen = this.opened;
  }

  onOpen(event: AccordionTabOpenEvent) {
    this.isPanelOpen = true;
    console.log('Abriu:', event);
  }

  onClose(event: AccordionTabCloseEvent) {
    this.isPanelOpen = false;
    console.log('Fechou:', event);
  }



}
